import { createEffect, Actions, ofType } from "@ngrx/effects";
import { Injectable } from "@angular/core";
import { ReportsDataAction, LOAD_LINESCORE, LoadLinescoreSuccess, LoadLinescoreFail, LOAD_BRANDS_DATA, LoadBrandsDataSuccess, LoadLinescore, LoadBrandsData, LOAD_VERBATIMS, LoadVerbatims, LoadVerbatimsSuccess, LoadVerbatimsFail, LOAD_OTHER, LoadOther, LoadOtherSuccess, LoadOtherFail, LOAD_DRIVER, LoadDriver, LoadDriverSuccess, LoadDriverFail, LOAD_RATINGS, LoadRatingsSuccess, LoadRatingsFail, LoadRatings, ARCHIVE_REPORT, ArchiveReportSuccess, ArchiveReportFail, ARCHIVE_REPORT_SUCCESS, LOAD_LINESCORES, LoadLinescoresSuccess, LoadLinescoresFail, LoadBrandsDataFail, LOAD_LINESCORES_FAIL, LOAD_LINESCORE_FAIL, LOAD_BRANDS_DATA_FAIL, LOAD_OTHER_FAIL, LOAD_DRIVER_FAIL, LOAD_VERBATIMS_FAIL, ReportsErrorAction, DELETE_ARCHIVE_FAIL, DELETE_ARCHIVE, DeleteArchiveSuccess, DeleteArchiveFail, DELETE_ARCHIVE_SUCCESS, LOAD_CELL, CellLoaded, LOAD_LINESCORE_SUCCESS, LOAD_BRANDS_DATA_SUCCESS, LOAD_DRIVER_SUCCESS, LOAD_OTHER_SUCCESS, LOAD_RATINGS_SUCCESS } from "../actions";
import { map, switchMap, catchError, filter, tap, take } from "rxjs/operators";
import { Verbatims, LinescoreData, DriverData } from "../../models";
import { of, Observable } from "rxjs";
import { FORMAT_TABLES, WorkerAction, TABLES_FORMATTED, ReportCacheService } from "core";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ArchiveConfirmComponent } from '../../archive-confirm/archive-confirm.component';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ErrorComponent } from '../../error/error.component';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';
import { select, Store } from '@ngrx/store';
import { getCache } from '../selectors';
import { cell, ReportsState } from '../reducers';
// import { LoadCellFail } from "projects/menus/src/app/store";
import { Cell, LsTable } from "core-lib";

const ERROR_ACTIONS = [
    LOAD_LINESCORE_FAIL,
    // LOAD_BRANDS_DATA_FAIL,
    LOAD_OTHER_FAIL,
    LOAD_DRIVER_FAIL,
    LOAD_VERBATIMS_FAIL,
    // DELETE_ARCHIVE_FAIL
];

@Injectable()
export class LinescoreEffects {

    worker: Worker;
    worker$: Observable<WorkerAction>;

    constructor(
        private actions$: Actions<ReportsDataAction>,
        private rcServ: ReportCacheService,
        private dialog: MatDialog,
        private snackbar: MatSnackBar,
        private store: Store<ReportsState>,
    ) {
        if (typeof Worker !== 'undefined') {
            // Create a new
            this.worker = new Worker(new URL('../../reports.worker', import.meta.url), { type: 'module' });
            this.worker$ = new Observable(obs => {
                this.worker.onmessage = ({ data }) => {
                    obs.next(data);
                };
                this.worker.onerror = function (err) {
                    obs.error(err);
                }
            });
            // this.worker.postMessage({ type: SAY_HI, payload: 'James' });
        } else {
            // Web Workers are not supported in this environment.
            // You should add a fallback so that your program still executes correctly.
            this.worker$ = of(null);
        }
        this.worker$.subscribe(result => {
            console.log(result);
        }, err => {
            console.log('WORKER ERROR: ', err);

        });
    }

    loadLinescore$ = createEffect(() => this.actions$.pipe(
        ofType(LOAD_LINESCORE),
        switchMap(({ payload: cacheKey }: LoadLinescore) => {
            return this.rcServ.getReportData<LinescoreData>(cacheKey, 'linescore')
                .pipe(
                    map(result => new LoadLinescoreSuccess(result)),
                    catchError(err => httpErrorHandle(err, LoadLinescoreFail))
                )
        })
    ));

    // TODO: Move this to own file if it gets bigger.
    loadBrands$ = createEffect(() => this.actions$.pipe(
        ofType(LOAD_BRANDS_DATA),
        switchMap(({ payload: cacheKey }: LoadBrandsData) => {
            return this.rcServ.getReportData(cacheKey, 'competitors/1')
                .pipe(
                    map(result => new LoadBrandsDataSuccess(result)),
                    catchError(err => of(new LoadBrandsDataFail(err)))
                )
        })
    ));

    loadVerbatims$ = createEffect(() => this.actions$.pipe(
        ofType(LOAD_VERBATIMS),
        switchMap(({ payload: cacheKey }: LoadVerbatims) => {
            return this.rcServ.getReportData<Verbatims>(cacheKey, 'verbatims')
                .pipe(
                    map(result => new LoadVerbatimsSuccess(result)),
                    catchError(err => of(new LoadVerbatimsFail(err)))
                )
        })
    ));

    loadOther$ = createEffect(() => this.actions$.pipe(
        ofType(LOAD_OTHER),
        switchMap(({ payload: { cacheKey, crosstab } }: LoadOther) => {
            return this.rcServ.getReportData<Array<LsTable | { type: 'vwchart', series: any[] } | { type: 'information' }>>(cacheKey, crosstab ? 'crosstab' : 'tables').pipe(
                switchMap((result) => {
                    // return of(result.slice(0, 2)).pipe(
                    //     map(stuff => new LoadOtherSuccess(stuff))
                    // )

                    this.worker.postMessage({
                        type: FORMAT_TABLES,
                        payload: result.filter(item => item.type !== 'information')
                    });
                    return this.worker$.pipe(
                        filter((response: WorkerAction) => response.type === TABLES_FORMATTED),
                        map(response => new LoadOtherSuccess(response.payload as any[])),
                        take(1)
                    );
                }),
                catchError(err => of(new LoadOtherFail(err)))
            )
        })
    ));

    loadDriver$ = createEffect(() => this.actions$.pipe(
        ofType(LOAD_DRIVER),
        switchMap((action: LoadDriver) => {
            return this.rcServ.getReportData(action.payload, 'drivers')
                .pipe(
                    map((result: DriverData[]) => new LoadDriverSuccess(result)),
                    catchError(err => of(new LoadDriverFail(err)))
                );
        })
    ));

    loadRatings$ = createEffect(() => this.actions$.pipe(
        ofType(LOAD_RATINGS),
        switchMap((action: LoadRatings) => {
            return this.rcServ.getReportData(action.payload, 'ratings')
                .pipe(
                    map(result => new LoadRatingsSuccess(result)),
                    catchError(err => of(new LoadRatingsFail(err)))
                )
        })
    ));

    createArchive$ = createEffect(() => this.actions$.pipe(
        ofType(ARCHIVE_REPORT),
        switchMap(action => {
            return this.dialog.open<ArchiveConfirmComponent, any, string>(ArchiveConfirmComponent, {
                minWidth: '300px'
            }).afterClosed().pipe(
                switchMap(name => {
                    if (name) {
                        return this.rcServ.createArchive(action.payload, name)
                            .pipe(
                                map(result => new ArchiveReportSuccess(result)),
                                catchError(err => of(new ArchiveReportFail(err)))
                            );
                    }
                    return of(new ArchiveReportFail('USER_CANCELED'));
                })
            )
        })
    ));

    loadLinescores$ = createEffect(() => this.actions$.pipe(
        ofType(LOAD_LINESCORES),
        switchMap(action => {
            return this.rcServ.getReportData(action.payload, 'type3')
                .pipe(
                    map(result => new LoadLinescoresSuccess(result)),
                    catchError(err => httpErrorHandle(err, LoadLinescoresFail))
                );
        })
    ))

    archiveSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(ARCHIVE_REPORT_SUCCESS),
        tap(() => {
            this.snackbar.open('Archive Created', null, {
                duration: 3000
            });
        })
    ), { dispatch: false });

    archiveDeleted$ = createEffect(() => this.actions$.pipe(
        ofType(DELETE_ARCHIVE_SUCCESS),
        switchMap(() => {
            return this.store.pipe(
                select(getCache),
                tap(cache => {
                    location.href = `https://menus.linescale.com/client/${cache.client_id}/${cache.cell_id}`;
                })
            )
        })
    ), { dispatch: false })

    deleteArchive$ = createEffect(() => this.actions$.pipe(
        ofType(DELETE_ARCHIVE),
        switchMap(action => {
            return this.dialog.open(ConfirmDialogComponent).afterClosed()
                .pipe(switchMap(confirmed => {
                    if (confirmed) {
                        return this.rcServ.deleteArchive(action.payload.archiveId)
                            .pipe(
                                map(result => new DeleteArchiveSuccess(result)),
                                catchError(err => of(new DeleteArchiveFail(err)))
                            );
                    }
                    return of(new DeleteArchiveFail({ error: 'Canceled' }));
                }));
        })
    ));

    errorDialog$ = createEffect(() => this.actions$.pipe(
        ofType(...ERROR_ACTIONS),
        switchMap((action: ReportsErrorAction) => this.dialog.open(ErrorComponent, {
            data: {
                error: action.payload.error?.debug ?? 'Something went wrong',
                actions: {
                    confirm: {
                        label: 'Dismiss',
                        effect(callback?: () => void) {
                            // location.href = 'https://menus.linescale.dev/clients';
                            // TODO: Maybe delete this as the error component is static in nature. Effects probably are better suited in the opposite direction. Invoked by the error component and passed by the origin
                            if (callback)
                                callback();
                        }
                    }
                }
            },
            disableClose: true
        }).afterClosed())
    ), { dispatch: false });

    // loadCell$ = createEffect(() => this.actions$.pipe(
    //     ofType(LOAD_CELL),
    //     // switchMap(action => this.cs.getCell(action.payload.surveyId)
    //     switchMap(action => {
    //         let cell$: Observable<Cell>;
    //         console.log(action.payload);

    //         if (action.payload.cache?.is_consolidated)
    //             cell$ = this.http.get<Cell>(`${environment.apiUrl}/report/${action.payload.cache.report_id}/survey`);
    //         else cell$ = this.http.get<Cell>(`${environment.apiUrl}/survey/${action.payload.surveyId}`)

    //         return cell$.pipe(
    //             map(result => new CellLoaded(result)),
    //             catchError(err => of(new LoadCellFail(err)))
    //         );
    //     })
    // ));

    clearNotifier$ = createEffect(() => this.actions$.pipe(
        ofType(LOAD_LINESCORE_SUCCESS, LOAD_BRANDS_DATA_SUCCESS, LOAD_DRIVER_SUCCESS, LOAD_OTHER_SUCCESS, LOAD_RATINGS_SUCCESS),
        tap(() => this.snackbar.dismiss())
    ), { dispatch: false });

}

function httpErrorHandle(error: HttpErrorResponse, action): Observable<any> {
    const nextError = error.statusText === 'Unknown Error' ? { error: "Something is wrong with this report. If it's a live report it may have expired. Go back to the survey menu and run the report again." } : error.error;
    return of(new action(nextError));
}

